/**
 * Pille (Kopie aus Axis): Status, Typ, Zähler. **Farbe trägt nie allein die Aussage** — eine Pille hat immer ein Wort
 * und, wo es um einen Zustand geht, einen Punkt oder ein Symbol davor. Der Punkt nimmt seine Farbe aus `dot`
 * (`--c` am Element), damit die Zustandsfarben an einer Stelle stehen (die Seite, die sie kennt) und nicht in CSS.
 */

import type { CSSProperties, ReactNode } from 'react';

import { classNames } from './classNames';

export interface PillProps {
  /** Farbe des Punkts vor dem Wort — ein Token (`var(--color-…)`). */
  dot?: string;
  /** Ein Symbol statt des Punkts. */
  icon?: ReactNode;
  className?: string;
  children: ReactNode;
}

export function Pill({ dot, icon, className, children }: PillProps) {
  return (
    <span className={classNames('ksb-pill', className)}>
      {icon}
      {dot !== undefined && (
        <span className="ksb-dot" style={{ '--c': dot } as CSSProperties} aria-hidden="true" />
      )}
      {children}
    </span>
  );
}
